import { Schedule, Id } from 'NSwag/ServerClient/Client.nswag';
import { Action } from 'redux';

export enum SchedulesActionTypes {
    Add = 'ADD_SCHEDULES',
    Modify = 'MODIFY_SCHEDULES',
    Delete = 'DELETE_SCHEDULES'
}

export interface AddSchedules extends Action {
    type: SchedulesActionTypes.Add;
    schedules: Schedule[];
}

export interface ModifySchedules extends Action {
    type: SchedulesActionTypes.Modify;
    schedules: Schedule[];
}

export interface DeleteSchedules extends Action {
    type: SchedulesActionTypes.Delete;
    ids: Id[];
}